import {
  SEASONAL_PROJECTS_LIST_LOADING,
  SEASONAL_PROJECTS_LIST_SUCCESS,
  SEASONAL_PROJECTS_LIST_FAILURE,
} from "redux/types";

const initialState = {
  seasonalProjectsLoading: false,
  seasonalProjects: null,
  errors: null,
};

export const seasonalProjectsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SEASONAL_PROJECTS_LIST_LOADING:
      return { ...state, seasonalProjectsLoading: action.payload };
    case SEASONAL_PROJECTS_LIST_SUCCESS:
      return { ...state, seasonalProjects: action.payload };
    case SEASONAL_PROJECTS_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
